var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100vw","height":"100vh","display":"flex","justify-content":"center","align-items":"center","background":"white","z-index":"50000"}},[_c('h1',[_vm._v("Logging Out")])])
}]

export { render, staticRenderFns }